document.addEventListener('DOMContentLoaded', () => {

    // Firebase stillingar
    const firebaseConfig = {
        apiKey: "AIzaSyDJngLtHVQ-1Q_muZPQBsYczWX0e6LNV8w",
        authDomain: "bestathu-80012.firebaseapp.com",
        projectId: "bestathu-80012",
        storageBucket: "bestathu-80012.appspot.com",
        messagingSenderId: "944448419154",
        appId: "1:944448419154:web:becfe8ffa4599c873a768b"
    };

    firebase.initializeApp(firebaseConfig);
    const auth = firebase.auth();
    const db = firebase.firestore();

    // DOM Elements
    const loadingSpinner = document.getElementById('loading-spinner');
    const pageContent = document.getElementById('page-content');
    const addGoalForm = document.getElementById('add-goal-form');
    const activeGoalsList = document.getElementById('active-goals-list');
    const completedGoalsList = document.getElementById('completed-goals-list');
    
    let currentUser = null;

    AOS.init({ duration: 800, once: true });

    auth.onAuthStateChanged(user => {
        if (user) {
            currentUser = user;
            pageContent.style.display = 'block';
            loadingSpinner.style.display = 'none';
            fetchAndRenderGoals();
        } else {
            window.location.href = '/pages/member-dashboard'; 
        }
    });

    async function fetchAndRenderGoals() {
        if (!currentUser) return;
        
        try {
            const userDocRef = db.collection('userProgress').doc(currentUser.uid);
            const doc = await userDocRef.get();
            
            const goals = (doc.exists && Array.isArray(doc.data().goals)) ? doc.data().goals : [];
            
            activeGoalsList.innerHTML = '';
            completedGoalsList.innerHTML = '';

            if (goals.length === 0) {
                activeGoalsList.innerHTML = '<p style="text-align:center; color: var(--light-text);">Engin virk markmið. Bættu við þínu fyrsta markmiði hér fyrir ofan!</p>';
            } else {
                goals.sort((a, b) => new Date(a.targetDate) - new Date(b.targetDate)).forEach(goal => {
                    const goalElement = createGoalElement(goal);
                    if (goal.isComplete) {
                        completedGoalsList.appendChild(goalElement);
                    } else {
                        activeGoalsList.appendChild(goalElement);
                    }
                });
            }
        } catch (error) {
            console.error("Villa við að sækja markmið:", error);
            alert("Ekki tókst að sækja markmiðin þín. Reyndu að endurhlaða síðuna.");
        }
    }

    function createGoalElement(goal) {
        const goalElement = document.createElement('div');
        goalElement.className = `goal-item ${goal.isComplete ? 'is-completed' : ''}`;
        goalElement.dataset.id = goal.id;

        // =============================================================
        // === HÉR ER LAGFÆRINGIN                                     ===
        // === Setjum sjálfgefið gildi ef 'category' vantar          ===
        // =============================================================
        const category = goal.category || 'annað'; 
        const categoryText = category.charAt(0).toUpperCase() + category.slice(1).replace('-', ' ');
        const formattedDate = new Date(goal.targetDate).toLocaleDateString('is-IS', { day: '2-digit', month: '2-digit', year: 'numeric' });

        goalElement.innerHTML = `
            <input type="checkbox" class="goal-item-checkbox" data-id="${goal.id}" ${goal.isComplete ? 'checked' : ''}>
            <div class="goal-details">
                <div class="goal-text">${goal.text}</div>
                <div class="goal-meta">
                    <span class="goal-category-tag" data-category="${category}">${categoryText}</span>
                    <span>🎯 ${formattedDate}</span>
                </div>
            </div>
            <div class="goal-actions">
                <button class="delete-goal-btn" data-id="${goal.id}"><i class="fas fa-trash"></i></button>
            </div>
        `;
        return goalElement;
    }

    addGoalForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        const goalText = document.getElementById('goal-text').value;
        const goalCategory = document.getElementById('goal-category').value;
        const goalDate = document.getElementById('goal-date').value;

        if (!goalText || !goalCategory || !goalDate || !currentUser) return;

        const newGoal = {
            id: Date.now().toString(),
            text: goalText,
            category: goalCategory,
            targetDate: goalDate,
            isComplete: false
        };

        const userDocRef = db.collection('userProgress').doc(currentUser.uid);

        try {
            const doc = await userDocRef.get();
            const existingGoals = (doc.exists && Array.isArray(doc.data().goals)) ? doc.data().goals : [];
            const updatedGoals = [...existingGoals, newGoal];

            await userDocRef.set({ goals: updatedGoals }, { merge: true });
            
            addGoalForm.reset();
            fetchAndRenderGoals();
        } catch (error) {
            console.error("VILLA VIÐ AÐ VISTA MARKMIÐ:", error);
            alert("Ekki tókst að vista markmiðið. Vinsamlegast reyndu aftur.");
        }
    });

    async function handleGoalAction(e) {
        if (!currentUser) return;

        const goalId = e.target.dataset.id;
        if (!goalId) return;

        const userDocRef = db.collection('userProgress').doc(currentUser.uid);
        let updatedGoals;

        try {
            const doc = await userDocRef.get();
            const goals = (doc.exists && Array.isArray(doc.data().goals)) ? doc.data().goals : [];
            
            const targetGoal = goals.find(g => g.id === goalId);
            if (!targetGoal) return;

            if (e.target.closest('.delete-goal-btn')) {
                if (confirm(`Ertu viss um að þú viljir eyða markmiðinu: "${targetGoal.text}"?`)) {
                    updatedGoals = goals.filter(goal => goal.id !== goalId);
                } else {
                    return;
                }
            } 
            else if (e.target.classList.contains('goal-item-checkbox')) {
                updatedGoals = goals.map(goal => 
                    goal.id === goalId ? { ...goal, isComplete: !goal.isComplete } : goal
                );
            } else {
                return; 
            }

            await userDocRef.update({ goals: updatedGoals });
            fetchAndRenderGoals();

        } catch (error) {
            console.error("VILLA VIÐ AÐGERÐ Á MARKMIÐI: ", error);
            alert("Eitthvað fór úrskeiðis. Reyndu aftur.");
        }
    }
    
    // Notum event delegation á allt svæðið til að ná í atburði
    const goalsArea = document.querySelector('.goals-container').parentElement;
    goalsArea.addEventListener('click', handleGoalAction);

});